import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import ProjectCriticalPeriodsList from './ProjectCriticalPeriodsList';
import { useShowContext } from 'framework/show';
import { EditableListFormShowTemplate } from 'framework/list';
import useProjectTeamService from '../useProjectTeamService';
import { TeamShowType } from '../types';

const ProjectCriticalPeriodsLayout = () => {
  const { getCriticalPeriodsValidationSchema } = useProjectTeamService();
  const { data } = useShowContext<TeamShowType>();
  const showData = data.getData();

  const criticalPeriods = [...(showData?.criticalPeriods || [])];

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      getValidationSchemaFunc={getCriticalPeriodsValidationSchema}
      submitFormFunc={() => Promise.resolve()}
      afterSubmit={{
        message: 'Periods have been successfully updated.',
      }}
      getDataFunc={() =>
        Promise.resolve({
          criticalPeriods,
        })
      }
    >
      <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
        <EditableListFormShowTemplate listSource="criticalPeriods">
          <ProjectCriticalPeriodsList />
        </EditableListFormShowTemplate>
      </ShowSection>
    </FormShowTemplate>
  );
};

export default ProjectCriticalPeriodsLayout;
